<template>
  <Verifications :is-new-verifications="false" />
</template>

<script lang="ts" setup>
import Verifications from '@pages/images/verifications/Verifications.vue';
</script>

<style lang="scss" scoped>
</style>
